// extracted by mini-css-extract-plugin
export default {"factor-box":"factor_factor-box__YcVl+"};